exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "@media only screen and (max-width: 480px){.v-application .headline[data-v-115d6167]{font-size:1.2rem !important}}", "", {"version":3,"sources":["/home/webuser/salag/releases/35/spa/src/pages/profile/profileEdit/ProfileEdit.scss"],"names":[],"mappings":"AAII,0CADF,0CAEI,2BAAA,CAAA,CAAA","file":"ProfileEdit.scss?vue&type=style&index=0&id=115d6167&prod&lang=scss&scoped=true&external","sourcesContent":["@import '../../../assets/scss/variables';\n\n.v-application {\n  .headline {\n    @media only screen and (max-width: 480px) {\n      font-size: 1.2rem!important;\n    }\n  }\n}\n"],"sourceRoot":""}]);

// exports
